class BxfInlineMenuConstants {
    // eslint-disable-next-line @typescript-eslint/prefer-as-const
    static COMPONENT_NAME = 'bxf-inline-menu';
    static STRING = {
        SHOW: 'bxf-inline-menu__show',
        HIDE: 'bxf-inline-menu__hide',
        FLYOUT: 'bxf-inline-menu__flyout',
        TARGET: 'target',
        CHECK: 'checkmark',
        ALERT_ICON: 'alert-2',
        ARROW_RIGHT: 'arrow-right',
        FLYOUT_DATA: 'flyoutData',
        ALERT: 'alert',
        BXF_INLINE_MENU: 'bxf-inline-menu',
        MENU_ITEM_WRAPPER: 'bxf-inline-menu__item-wrapper',
        MENU_ITEM: 'bxf-inline-menu__item',
        MENU_ITEM_COMPACT: 'bxf-inline-menu__item--compact',
        MENU_GROUP: 'bxf-inline-menu__group',
        GROUP_SEPARATOR: 'bxf-inline-menu__group-separator',
        MENU_LEFT_ICON: 'bxf-inline-menu__left-icon',
        MENU_LEFT_ICON_NO: 'bxf-inline-menu__no-left-icon',
        ITEM_RIGHT: 'bxf-inline-menu__right',
        MENU_RIGHT_ICON: 'bxf-inline-menu__right-icon',
        MENU_RIGHT_ICON_NO: 'bxf-inline-menu__no-right-icon',
        SECONDARY_LABEL: 'bxf-inline-menu__secondary-label',
        CLOSE_BUTTON: 'bxf-inline-menu__close-button',
        BUTTON: 'button',
        IN_LINE_MENU: 'in-line-menu',
        SELECTED: 'selected',
        DISABLED: 'disabled',
        SCROLL_CLASS: 'bxf-inline-menu__disable-scroll',
        BXF_THEME_LIGHT: 'bxf-theme-light',
        MENU_NAV_BACKGROUND: 'bxf-inline-menu__override-background',
        IS_NAV_MENU: 'isNavMenu',
        PRIMARY: 'primary',
        CONTAINER: 'bxf-inline-menu__container',
    };
}

export { BxfInlineMenuConstants as B };
